import { parseJwt } from "./globalMethods";

export function parseMyself(jwtToken) {
    let token = parseJwt(jwtToken);

    let myself = {
      me: true,
      displayName: token.context.user.name,
    }

    if (token.aud === 'jitsi' && token.iss === 'chat') {
      // jaas is little bit different
      myself.role = token.context.user.moderator == 'true' ? 'moderator' : 'participant'
    } else {
      myself.role = token.moderator == 'true' ? 'moderator' : 'participant'
    }

    return myself;
  }



// WEBPACK FOOTER //
// ./src/functions/utils.js